
export function initAllModules(rootElement = document, moduleNames = null, args = {}) {
    let kdModules = [];
    rootElement.querySelectorAll('*[kd-module]').forEach(elm => {
        if (elm.hasAttribute('kd-initted')) {
            return;
        }
        kdModules.push(initSingleModule(elm, moduleNames, args));
    });

    return kdModules;
}

export function initSingleModule(elm, moduleNames = null, args = {}) {
    
    moduleNames = moduleNames || elm.getAttribute('kd-module');

    if (typeof moduleNames === 'function') {
        moduleNames = [moduleNames];
    } else {
        moduleNames = moduleNames.split(',').map(moduleName => moduleName.trim());
    }

    moduleNames.forEach(moduleName => {
        let moduleFn;
        if (typeof moduleName === 'function') {
            moduleFn = moduleName;
        } else {
            moduleFn = window.modules[moduleName] || window[moduleName];
        }

        if (typeof moduleFn !== 'function') {
            throw new Error(`Module ${moduleName} not found.`);
        }
        let module = new moduleFn(elm, args);
        elm.kdModule = module;
    });
    
    elm.setAttribute('kd-initted', true);
    elm.dispatchEvent(new CustomEvent('kdinit'));
   
    return elm.kdModule;
}

export function onDelegatedClick(parent, selector, callback, useCapture) {
    return onDelegatedEvent('click', parent, selector, callback, useCapture);
}

export function onDelegatedEvent(eventName, parent, selector, callback, useCapture) {
    return parent.addEventListener(eventName, function(e) {

        let selectorTarget = e.target.closest(selector);

        if (!selectorTarget) {
            return;
        }

        e.selectorTarget = selectorTarget;

        callback(e);
        
    }, useCapture);
}

export function onClickOutside(domElement, callback) {
    document.addEventListener('click', event => {
        if (!domElement.contains(event.target)) {
            callback(event);
        }
    });
}

export function objectToFormData(obj) {
    let formData = new FormData();

    for (let key in obj) {
        formData.append(key, obj[key]);
    }

    return formData;
}

export function formElementToObject(form) {
    let formData = new FormData(form);
    return formDataToObject(formData);
}

export function formDataToObject(formData) {

    let data = {};

    for (let key of formData.keys()) {
        data[key] = formData.get(key);
    }

    return data;
}

export function genericElementToFormData(el) {
    const formData = new FormData();
    const inputs = el.querySelectorAll('input, textarea, select');
    
    inputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) formData.append(input.name, input.value);
        } else if (input.tagName === 'SELECT' && input.multiple) {
        [...input.options].forEach(option => {
            if (option.selected) formData.append(input.name, option.value);
        });
        } else {
        formData.append(input.name, input.value);
        }
    });
    
    return formData;
}

// https://gist.github.com/nmsdvid/8807205
export function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

export function addParamsToUrl(url, params) {
    let urlObj = new URL(url, window.location.origin);

    for (let key in params) {
        urlObj.searchParams.delete(key);
        urlObj.searchParams.append(key, params[key]);
    }
    return urlObj.toString();
}

/**
 * @since 2024-05-06 first param containers could be an array
 */
export function setLoading(containers, loading) {

    if (!Array.isArray(containers)) {
        containers = [containers];
    }

    containers.forEach(container => {
        let isStatic = window.getComputedStyle(container).position === 'static';

        if (loading) {
            if (isStatic) {
                container.style.position = 'relative';
            }
            container.classList.add('is-loading');
            
        } else {
            container.classList.remove('is-loading');
        }
    });
}

export function viewTransition(callback) {
    if (document.startViewTransition) {
        document.startViewTransition(() => {
            callback();
        });
    } else {
        callback();
    }
}

export function isCursorAtEnd(inputElement) {
    return inputElement.selectionStart === inputElement.value.length;
}

export function isCursorAtStart(inputElement) {
    return inputElement.selectionStart === 0;
}

export function fetchPostJson(url, options) {
    options = Object.assign({ method: 'POST', }, options);
    return fetch(url, options).then(res => res.json());
}

export function fetchGetJson(url, options) {
    options = Object.assign({ method: 'GET', }, options);
    return fetch(url, options).then(res => res.json());
}

export function ajaxUpdatePagePart(selector, url) {

    url = url || window.location.href;

    let request = new Request(url, {
        headers: { 'X-Is-Ajax': '1' },
    });

    let replaceTarget = document.querySelector(selector);
    
    setLoading(replaceTarget, true);

    fetch(request)
        .then(res => {
            return res.text();
        })
        .then(res => {
            setLoading(replaceTarget, false);

            let html;
            
            let tmpDiv = document.createElement('div');
            tmpDiv.innerHTML = res;
            let sourceElement = tmpDiv.querySelector(selector);

            if (sourceElement) {
                html = sourceElement.innerHTML;
            } else {
                html = res;
            }
            
            viewTransition(() => {
                replaceTarget.innerHTML = html;
                replaceTarget.style.display = '';
                initAllModules(replaceTarget);
            });

        }).catch(err => {
            setLoading(replaceTarget, false);
            console.error(err);
        });

}

window.ajaxUpdatePagePart = ajaxUpdatePagePart;

export function tryJsonParse(str) {
    try {
        return JSON.parse(str);
    } catch(e) {
        return null;
    }
}

export function linearConversion(OldValue, OldMin, OldMax, NewMin, NewMax) {
    return (((OldValue - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin;
}

/**
 * @link https://dirask.com/posts/JavaScript-check-if-any-text-on-web-page-is-selected-with-caret-j8VwmD
 */
export function isTextSelected() {
    var selection = window.getSelection();
    return selection && selection.type === 'Range';
}

export function setCss(elements, styles, value = null) {

    if (typeof styles === 'string' && value !== null) {
        styles = {
            [styles]: value
        };
    }

    if (elements instanceof Element) {
        elements = [elements];
    } else if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    elements.forEach(element => {
        for (let property in styles) {
            element.style[property] = styles[property];
        }
    });
}

export function buildSelectOptions(options, selectedValue = null) {
    let html = '';
    options.forEach(option => {
        if (option.value === selectedValue) {
            html += `<option value="${option.value}" selected>${option.label}</option>`;
        } else {
            html += `<option value="${option.value}">${option.label}</option>`;
        }
    });

    return html;
}

/**
 * Reemplaza el contenido de un elemento identificado por un id por el de el mismo dentro del HTML pasado como parámetro.
 * @param DOMElement target 
 * @param string sourceHtml 
 * @param function callback 
 * 
 * @since 2024-03-15 If the target element is not found in the source html, the function will console log the response
 */
export function replacePageContent(target, sourceHtml, callback) {

    let domId = target.getAttribute('id');

    let html;
    let tmpDiv = document.createElement('div');
    tmpDiv.innerHTML = sourceHtml;
    let sourceElement = tmpDiv.querySelector('#' + domId);

    if (!sourceElement) {
        console.warn('Element with id ' + domId + ' not found in source html.');
        console.log(sourceHtml);
        return;
    }
    
    html = sourceElement.innerHTML;

    viewTransition(() => {
        target.scrollTop = 0;
        target.innerHTML = html;
        // target.style.display = '';
        initAllModules(target);

        callback && callback();
        
    });
}

/**
 * @since 2024-05-08 Added allow-scripts to sl-include
 */
export function createDrawerWithUrl(url, label, options = {}) {

    url = url.replace('{{t}}', Date.now());
    
    let drawer = document.createElement('sl-drawer');
    drawer.label = label;
    drawer.innerHTML = html`
        <sl-include src="${url}" allow-scripts>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
        </sl-include>
    `;

    if (options.class) {
        drawer.classList.add(options.class);
    }

    document.body.appendChild(drawer);

    customElements.whenDefined('sl-drawer').then(() => {
        drawer.show();
    });

    drawer.addEventListener('sl-after-hide', event => {
        if (event.target === drawer) {
            drawer.remove();
        }
    });

    return drawer;
}

/**
 * @since 2024-05-08 Added allow-scripts to sl-include
 */
export function createDialogWithUrl(url, label, options = {}) {

    url = url.replace('{{t}}', Date.now());
    
    let dialog = document.createElement('sl-dialog');
    dialog.label = label;
    dialog.innerHTML = html`
        <sl-include src="${url}" allow-scripts>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
        </sl-include>
    `;

    if (options.class) {
        dialog.classList.add(options.class);
    }

    document.body.appendChild(dialog);

    customElements.whenDefined('sl-dialog').then(() => {
        dialog.show();
    });

    dialog.addEventListener('sl-after-hide', event => {
        if (event.target === dialog) {
            dialog.remove();
        }
    });

    return dialog;
}

export function html(strings, ...values) {
    let str = '';
    strings.forEach((string, i) => {
        str += string + (values[i] || '');
    });
    return str;
}

/**
 * @since 2024-05-06 Added X-Toastify
 */
export function processStandardBackendHeaders(response, scopeElement = null) {

    // Dispatch Event
        let eventName = response.headers.get('X-Dispatch-Event');
        if (eventName) {
            scopeElement.dispatchEvent(new CustomEvent(eventName, { bubbles: true, }));
        }

    // Flash message
        let flashMessage = response.headers.get('X-Flash-Message');
        if (flashMessage) {
            if (typeof swalAlert === 'function') {
                swalAlert(flashMessage)
            } else {
                alert(flashMessage);
            }
        }

        let toastifyMessage = response.headers.get('X-Toastify');
        if (toastifyMessage && typeof Toastify !== 'undefined') {
            let background = response.headers.get('X-Toastify-Background') || 'green';
            Toastify({ 
                text: toastifyMessage, 
                duration: 3000,
                style: {
                    background: background,
                    color: 'white'
                }
            }).showToast();
        }

    // Redirect
        let redirect = response.headers.get('X-Location');

        if (redirect) {
            location.href = redirect;
        }

    return response;

}


export function tryGlobalDataOrJson(key) {
    window._globalData = window._globalData || {};
    if (key.startsWith('_globalData:')) {
        key = key.replace('_globalData:', '');
        return window._globalData[key] || null;
    }

    return tryJsonParse(key);
}